import Alpine from 'alpinejs'
import masonry from 'alpinejs-masonry'


export const initAlpine = () => {
  
  window.Alpine = Alpine
  
	Alpine.plugin(masonry)
	
  Alpine.start()

}

export default () => {}